import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53a3fc4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OTabelaMembrosProjeto__Perfil" }
const _hoisted_2 = { class: "OTabelaMembrosProjeto__NomeEmail" }
const _hoisted_3 = ["onUpdate:modelValue"]

import Column from "primevue/column"
  import DataTable, { DataTableCellEditCompleteEvent } from "primevue/datatable"
  import Avatar from "primevue/avatar"
  import { MembroDoProjeto } from "@/repositorios/projeto/projeto.modelo"
  import Skeleton from "primevue/skeleton"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { useI18n } from "vue-i18n"

  interface Props {
    destino?: string
    membrosSelecionados: MembroDoProjeto[]
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaMembrosProjeto',
  props: {
    destino: null,
    membrosSelecionados: null
  },
  emits: ["atualizarCodigo"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (
      event: "atualizarCodigo",
      value: {
        campo: "codigo"
        novoValor: string
        valorAntigo: string
        idUsuario: string
      }
    ): void
  }), expose: any, slots: any, attrs: any }) {

  // framework cores
  // componentes
  
  

  const { t } = useI18n()

  const ALTURA_RELATIVA_DA_TABELA = "calc(100vh - 445px)"

  const { pegarIniciais } = usarFuncoesStrings()
  const { onSucesso } = usarMensagemUsuario()
  const fotoOuIniciais = (foto: string, nome: string) => {
    return foto || pegarIniciais(nome)
  }

  const atualizarCampoCodigo = (event: DataTableCellEditCompleteEvent) => {
    const { value, newValue } = event
    emitir("atualizarCodigo", {
      campo: "codigo",
      novoValor: newValue,
      valorAntigo: value,
      idUsuario: event.data.idUsuario,
    })
    onSucesso({
      resumo: t("salvoComSucesso"),
      detalhes: t("codigoEditadoComSucesso"),
    })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    onCellEditComplete: atualizarCampoCodigo,
    class: "OTabelaMembrosProjeto p-datatable-sm",
    "data-key": "id",
    "data-testid": "OTabelaMembrosProjeto",
    "edit-mode": "cell",
    paginator: true,
    "responsive-layout": "scroll",
    rows: 30,
    "scroll-height": ALTURA_RELATIVA_DA_TABELA,
    scrollable: "",
    "striped-rows": "",
    value: __props.membrosSelecionados
  }, {
    loading: _withCtx(() => [
      _createVNode(_unref(Skeleton), {
        height: "100%",
        width: "100%"
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OTabelaMembrosProjeto__Column",
        field: "nome",
        header: _unref(t)('profissionais'),
        "show-add-button": false,
        "show-filter-operator": false,
        sortable: ""
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Avatar), {
              class: "OTabelaMembrosProjeto__Avatar",
              "data-testid": "OTabelaMembrosProjeto__Avatar",
              label: fotoOuIniciais(data.foto, data.nome),
              shape: "circle"
            }, null, 8, ["label"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(data.nome), 1),
              _createElementVNode("small", null, _toDisplayString(data.emailUsuario ? data.emailUsuario : _unref(t)('emailNaoInformado')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OTabelaMembrosProjeto__Column",
        field: "codigo",
        header: _unref(t)('codigoDoProjeto'),
        "show-add-button": false,
        "show-filter-operator": false
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.codigo), 1)
        ]),
        editor: _withCtx(({ data, field }) => [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            class: "OTabelaMembrosProjeto_CodigoDoMembro",
            "data-testid": "OTabelaMembrosProjeto_CodigoDoMembro",
            name: "codigo",
            type: "text"
          }, null, 8, _hoisted_3), [
            [
              _vModelText,
              data[field],
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["value"]))
}
}

})